import React from "react";

import { faGavel } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components/macro";

import { Row } from "components/Layout";

const Icon = styled(FontAwesomeIcon).attrs({
  icon: faGavel,
})(
  ({ theme, color, margin, fontSize }) => `
    color: ${theme.colors[color] || theme.colors.primary};
    font-size: ${theme.fontSizes[fontSize] || theme.fontSizes.epsilon}px;
    margin: ${
      typeof margin === "number" ? theme.space[margin] : theme.space[1]
    }px;
`,
);

export const ComplianceEmailRecipientIcon = ({
  color,
  fontSize = "epsilon",
}) => (
  <Row
    alignCenter
    justifyCenter
    minHeight="28px"
    maxHeight="28px"
    title="Compliance Report Recipient"
  >
    <Icon color={color} fontSize={fontSize} />
  </Row>
);
